function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 27,
  r: 12,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.1204 34.0846L29.7054 7.3165C27.1875 2.8945 20.8204 2.8945 18.3116 7.3165L2.88752 34.0846C0.36967 38.5066 3.5034 44 8.58439 44H39.3692C44.4502 44 47.6383 38.4521 45.1204 34.0846ZM23.9994 38.0616C22.659 38.0616 21.545 36.9448 21.545 35.6009C21.545 34.2571 22.659 33.1402 23.9994 33.1402C25.3399 33.1402 26.4539 34.2571 26.3996 35.6645C26.463 36.9448 25.2855 38.0616 23.9994 38.0616ZM26.2365 22.1533C26.1278 24.0602 26.0101 25.9579 25.9014 27.8647C25.8471 28.4821 25.8471 29.0451 25.8471 29.6535C25.7927 30.6614 25.0048 31.4423 23.9994 31.4423C22.9941 31.4423 22.2152 30.7159 22.1518 29.708C21.9888 26.7388 21.8167 23.8241 21.6537 20.8549C21.5993 20.074 21.545 19.284 21.4816 18.5031C21.4816 17.2138 22.2062 16.1514 23.3836 15.8154C24.561 15.534 25.7293 16.0969 26.2365 17.2138C26.4086 17.6042 26.463 17.9947 26.463 18.4487C26.4086 19.6926 26.2909 20.9275 26.2365 22.1533Z",
  fill: "url(#paint0_linear_155_4340)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_155_4340",
  x1: 46,
  y1: 4,
  x2: 1.60464,
  y2: 43.5563,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3535"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D30000"
})));

function SvgAlertDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDanger);
export default __webpack_public_path__ + "static/media/alert-danger.5fd51d23.svg";
export { ForwardRef as ReactComponent };